export default __webpack_public_path__ + "static/media/AFM_rond_risicoscore3.d1409808.jpg";